import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@systemeio/components';
import React from 'react';
import { ChartCard } from 'shared/components/chart/chart-card';
const ChartsSkeleton = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ChartCard className="tablet:w-[calc(50%-10px)] desktop:w-[calc(50%-10px)] h-[340px]" title={<Skeleton className="h-[16px] w-[70px] rounded-md text-transparent">.</Skeleton>} value={<Skeleton className="h-[20px] w-[80px] rounded-md text-transparent">.</Skeleton>} headerAction={<Skeleton className="h-[24px] w-[56px] rounded-md text-transparent">.</Skeleton>}><Skeleton className="rounded-md py-[90px] text-transparent">.</Skeleton></ChartCard>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default ChartsSkeleton;